import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { approvalApiRef, ApprovalClient } from './api/ApprovalClient';

export const scaffolderApprovalPlugin = createPlugin({
  id: 'scaffolder-approval',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: approvalApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new ApprovalClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const ApprovalsPage = scaffolderApprovalPlugin.provide(
  createRoutableExtension({
    name: 'ApprovalsPage',
    component: () =>
      import('./components/ApprovalsPage').then(m => m.ApprovalsPage),
    mountPoint: rootRouteRef,
  }),
);
